import { Typography } from "@material-ui/core";
import { FC } from "react";
import { useSelector } from "react-redux";

import { ReduxState } from "../../../types/redux.types";
import { ILabeledValue } from "../../../types/resource.types";

const BrandStatus: FC<any> = ({ record }) => {
  const statusEnum = useSelector<ReduxState, ILabeledValue>((state) => state.enums.status);

  return <Typography variant="body2">{statusEnum[record.status].label.en}</Typography>;
};

export default BrandStatus;
